<template>
  <div class="app-activate-auto-top-up-wrapper">
    <activate-auto-top-up
      :monthly-value="monthlyValue"
      :next-step="confirmModal"
      :topUp.sync = "topUp"
    >
      <template v-for="slot in possibleChildSlotsFor('AutoTopUp')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </activate-auto-top-up>
    <ProcessConfirmModal
      :show.sync = "showModal"
      @hidden = "setActivationView(activateStepName)"
      @back = "setActivationView(activateStepName)"
      @next = "saveAutoTopUp()"
      :slotData = "slotData"
      :loading="loading"
      :disabled-next="loading"
    >
      <template v-for="slot in possibleChildSlotsFor('Modal', selectedType)" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </ProcessConfirmModal>
  </div>
</template>
<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import processSteps from '@/mixins/processSteps'
import ActivateAutoTopUp, { stepName as activateStepName } from '@/components/process/generic/TopUp/ChangeAutoTopUp/ActivateAutoTopUp.vue'
import ProcessConfirmModal, { stepName as confirmModal } from '@/components/generic/ProcessConfirmModal.vue'
import slotProxy from '@/mixins/slotProxy'
import preFilledObjectInput from '@/mixins/preFilledObjectInput'

export const stepName = 'activateWrapper'

export default {
  name: 'ActivateAutoTopUpWrapper',
  import: { activateStepName, confirmModal },
  data () {
    return {
      loading: false
    }
  },
  created () {
    this.setActivationView(activateStepName)
  },
  computed: {
    ...mapGetters('topUp', [
      'getActivationView', 'selectedType', 'selectedAmount', 'selectedTrigger'
    ]),
    showActivated () {
      return this.getActivationView === activateStepName
    },
    showModal () {
      return this.getActivationView === confirmModal
    },
    mediaId () {
      if (this.paymentType?.type === 'bankAccount') {
        return this.paymentType?.iban
      } else {
        return this.paymentType?.lastDigits
      }
    },
    slotData () {
      return {
        selectedAmount: this.selectedAmount / 100,
        selectedTrigger: this.selectedTrigger / 100,
        selectedPayment: this.paymentType,
        selectedMediaId: this.mediaId,
        selectedType: this.selectedType
      }
    }
  },
  methods: {
    backToActivate () {
      this.$emit('refresh')
    },
    async saveAutoTopUp () {
      this.loading = true
      await this.confirmAutoTopUp(activateStepName)
      this.backToActivate()
      this.loading = false
    },
    ...mapMutations('topUp', [
      'setActivationView'
    ]),
    ...mapActions('topUp', [
      'confirmAutoTopUp'
    ])
  },
  mixins: [
    processSteps(stepName, null, confirmModal),
    preFilledObjectInput('topUp', 'autoTopUp'),
    slotProxy()
  ],
  props: [
    'monthlyValue',
    'autoTopUp',
    'paymentType'
  ],
  components: { ActivateAutoTopUp, ProcessConfirmModal }
}
</script>
